import { IColumnDefinition } from "../../../models/IColumnDefinition";

export const timeAndSalesDefaultColumns: IColumnDefinition[] = [
  { title: "Last", field: "price", visible: true, sortOrder: 2 },
  { title: "Market", field: "excode", visible: true, sortOrder: 4 },
  { title: "Size", field: "size", visible: true, sortOrder: 3 },
  { title: "Time", field: "time", visible: true, sortOrder: 1 },
];
